import {
  Component,
  Input
} from '@angular/core'

@Component({
  selector: 'benchmark-result',
  templateUrl: './benchmark-result.component.html',
  styleUrls: ['./benchmark-result.component.less']
})
export class BenchmarkResultComponent {
  @Input() benchmark: number
  @Input() timePeriod: {name: string, value: string}
  @Input() loadingBenchmarks: boolean
  @Input() benchmarkClassName: string

  percentOptions = {
    digits: '1.0-0'
  }

  abs(value) {
    return Math.abs(value)
  }
}
